import React, { Component } from "react";
import {
  Row,
  Col,
  Input,
  Form,
  DatePicker,
  Checkbox
} from "antd";
import moment from "moment";
import {
  changeFormatdate,
} from "../../../../utils/formatdate";

import SecAbstainRemark from "../sector/include/SecAbstainRemark";
import SecAbstainDate from "../sector/include/SecAbstainDate";
import { checkStatusForm } from '../../../../utils/abstainTime';

class SecDocumentInformation extends Component {
  state = {
    detailForm: null,
    preLoadOnsubmit: false,
    loadingFullpage: true,
  };

  dateFormatNumber = (values) =>{
    const { propFormInput, } = this.props
    let valueReturn = propFormInput.getFieldValue(values)
    console.log("values dateFormatNumber",valueReturn)
   return changeFormatdate(moment(valueReturn))
}

  render() {
    const { propFormInput, isViewOnly, rawData, empCode, viewModeApproves = false,approveStatus = null } = this.props;
    const {} = this.state;
 
    console.log("rawData SecDocumentInformation", rawData)
    return (
      <div className="box-color-white">
        <Row
          gutter={16}
          type="flex"
          justify="left"
          align="top"
        >
          <Col xs={24} md={24} className="">
            <strong className="color-red">ข้อมูลการขอแก้ไขการลงเวลาทำงาน :</strong>
          </Col>
        </Row>
        <Row gutter={16} type="flex" justify="left" align="top" className="">

          <Col xs={8} md={8} className="pt-2" align="left">
            <Form.Item label={"เลขที่เอกสาร"} style={{ marginBottom: "0px" }}>
              {propFormInput.getFieldDecorator("documentNo", {
                initialValue: rawData?.documentNo ? rawData.documentNo : "-",
                // rules: [
                //   {
                //     required: true,
                //     message: "กรุณาระบุ เลขที่เอกสาร",
                //   },
                // ],
              })(<Input disabled={true}/>)}
            </Form.Item>
          </Col>

          <Col xs={8} md={8} className="pt-2" align="left">
            <Form.Item label={"วันที่ยื่นเรื่อง"} style={{ marginBottom: "0px" }}>
              {propFormInput.getFieldDecorator("requestAt", {
                initialValue: 
                rawData?.requestAt ? moment(rawData.requestAt) :  
                moment(),
                // rules: [
                //   {
                //     required: true,
                //     message: "กรุณาระบุ วันที่ยื่นเรื่อง",
                //   },
                // ],
            })( <DatePicker 
              format={this.dateFormatNumber("requestAt")} 
              placeholder="" 
              style={{ width:"100%" }} 
              disabled={true}
           />)}
            </Form.Item>
          </Col>
          
          <Col xs={8} md={8} className="pt-2" align="left">
            <Form.Item label={"สถานะเอกสาร"} style={{ marginBottom: "0px" }}>
              {propFormInput.getFieldDecorator("approveStatusStr", {
                 initialValue: rawData?.approveStatusName ? rawData.approveStatusName : "-",
                //  rules: [
                //   {
                //     required: true,
                //     message: "กรุณาระบุ สถานะเอกสาร",
                //   },
                // ],
              })(<Input disabled={true}/>)}
            </Form.Item>
          </Col>

          <Col xs={8} md={24} className="pt-2" align="left">
             <SecAbstainDate docId={rawData ? rawData.abTimeHdId : null} approveStatus={approveStatus} statusDoc={rawData ? rawData.approveStatus : null} viewModeApproves={!viewModeApproves} empCode={empCode} isViewOnly={isViewOnly} propFormInput={propFormInput} rawData={rawData ? rawData.tbAbstainTimeDt : []}/>
          </Col>
          {/* <SecAbstainRemark isViewOnly={isViewOnly} propFormInput={propFormInput}/> */}
         
          {/* <Col xs={8} md={8} className="pt-2" align="left">
            <Form.Item label={"เบอร์โทรศัพท์ที่ติดต่อได้"} style={{ marginBottom: "0px" }}>
            {propFormInput.getFieldDecorator("phoneNumber", {
                 initialValue: rawData ? rawData.phoneNumber : null,
              })(<Input />)}
            </Form.Item>
          </Col>
          <Col xs={8} md={8} className="pt-2" align="left">
            <Form.Item label={"เอกสารด่วน"} style={{ marginBottom: "0px",width:"24px" }}>
              {propFormInput.getFieldDecorator("isUrgent", {
                initialValue: rawData ? rawData.isUrgent : false,
              })(<Checkbox disabled={false} style={{ width:"24px" }} className="w-24"/>)}
            </Form.Item>
          </Col> */}
         
        </Row>
      </div>
      
    );
  }
}

export default SecDocumentInformation